export type EducatorVideoTranscript = {
  /** Short label for dialog title / SEO heading. */
  speaker: string;
  paragraphs: readonly string[];
};

/** Holly spotlight — back-to-school recommendation. */
export const HOLLY_VIDEO_TRANSCRIPT: EducatorVideoTranscript = {
  speaker: "Holly, 5th Grade Teacher",
  paragraphs: [
    "I just found the best math website, and I have to show you. If you’re getting ready for back-to-school season, it’s called PlayMath.org.",
    "There are so many interactive math games for students to choose from, starting in kindergarten and going all the way through middle school. I’m already adding it to my back-to-school plans because I know my incoming fifth graders are going to love these games.",
    "Not only are the games fun and engaging, but they also promote mathematical thinking and problem-solving, which is always really important to me as a teacher.",
    "PlayMath.org is the perfect website for back to school. I can’t wait to use it in my classroom for early finishers, sub plans, and math centers.",
  ],
};

/** Ryan spotlight — classroom tip / centers. */
export const RYAN_VIDEO_TRANSCRIPT: EducatorVideoTranscript = {
  speaker: "Ryan, Math Teacher",
  paragraphs: [
    "Teacher tip of the day: Don’t be afraid to test new resources in your classroom. Taking chances and trying new things is how you grow as a teacher.",
    "One resource I tried this year was PlayMath.org, and it was incredibly helpful. It kept my students focused and engaged while I worked with small groups. It’s quick, easy to use, and low-prep, which is so valuable when creating centers.",
    "The kids immediately got into it. They were having so much fun that they didn’t even realize they were practicing math skills, growing, and getting better.",
    "It’s also great for early finishers, quick brain breaks, or those moments when a lesson isn’t going as planned and you need a chance to regroup. When I’m running stations, centers, or pulling small groups, it makes everything easier.",
    "Did I mention it’s free? There are no ads or pop-ups, and you don’t have to sign students up. You simply open it and go.",
    "If you need a go-to classroom activity in your back pocket, this is definitely one of them.",
  ],
};

/** Garcia spotlight — sub plans. */
export const GARCIA_VIDEO_TRANSCRIPT: EducatorVideoTranscript = {
  speaker: "Garcia",
  paragraphs: [
    "I’m always looking for ways to keep my students busy and engaged. I was out recently, and I found the perfect resource to leave in my sub plans. It made the substitute’s job easier while keeping my students learning and engaged: PlayMath.org.",
    "Teachers, if you need a resource that keeps students busy while teaching and reinforcing math skills, add this to your lineup. Another plus is that it’s completely free and has no ads.",
    "My students think they’re playing a game, but in reality, they’re building their math skills. Check out PlayMath.org.",
  ],
};
